function formatDate (date) {
    if (date !== null && date !== undefined && date !== ""){
        const options = { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'UTC' };
        const formattedDate = new Date(date).toLocaleDateString('es-MX', options);

        //PARTIMOS LA FECHA POR LOS ESPACIOS
        const [day, month, year] = formattedDate.split(' de ');

        //REREGRESAMOS UN LITERAL STRING ARMANDO EL FORMATO DESEADO
        return `${day}/${month}/${year}`;
    }
    else return '';
    
}

export default formatDate;